import apiConfig from "../../apiConfig";

export const deleteAgent = async (at, agentId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/AGENTS/Del_Agent",
		{
			Agent_Id: agentId,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	// if (response.data.Status) {
	// 	return response.data;
	// }

	// return [];
	return response.data;
};
